module.exports = __webpack_public_path__ + "static/media/AG.8dcebf4b.pdf";